<p-toast />
<p-dialog
    header="Select Verified Address"
    [(visible)]="showLoqateMatchDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(720px, 95vw)' }">
    <div class="loqate-match-list">
        @for (match of loqateMatches; track $index) {
        <button type="button" class="loqate-match-item" (click)="selectLoqateMatch(match)">
            <span class="loqate-match-address">{{ getLoqateMatchDisplay(match) }}</span>
            <span class="loqate-match-meta">
                @if (match.AQI) { <span>AQI: {{ match.AQI }}</span> }
                @if (match.GeoAccuracy) { <span>Geo: {{ match.GeoAccuracy }}</span> }
            </span>
        </button>
        }
    </div>
</p-dialog>
<form *ngIf="projectForm" [formGroup]="projectForm" (ngSubmit)="onSubmit()" class="project-form">
    <div class="project-form-content" [ngClass]="{ 'step1-centered': isCreateMode && activeStep === 1, 'step3-centered': isCreateMode && activeStep === 3 }">
    @if (isCreateMode) {
    <p-stepper [value]="activeStep" [linear]="true" class="mb-4">
        <p-step-list>
            <p-step [value]="1">Business Unit</p-step>
            <p-step [value]="2">Project Details</p-step>
            <p-step [value]="3">Completed</p-step>
        </p-step-list>
    </p-stepper>

    @if (activeStep === 1) {
    <div class="step1-content">
        <div class="step1-field">
            <label for="businessUnitId" class="modal-label">Business Unit <span class="req">*</span></label>
            <p-select
                inputId="businessUnitId"
                formControlName="businessUnitId"
                [options]="businessUnitOptions"
                optionLabel="displayName"
                optionValue="id"
                placeholder="Select Business Unit"
                appendTo="body"
                class="w-full"
                [class.p-invalid]="f['businessUnitId'].invalid && f['businessUnitId'].touched">
            </p-select>
            @if (f['businessUnitId'].invalid && f['businessUnitId'].touched) {
            <small class="modal-error">
                Business Unit is required
            </small>
            }
            @if (isOthersBusinessUnit) {
            <small class="modal-error">
                Project creation is currently disabled for Others.
            </small>
            }
        </div>
    </div>
    }
    }

    @if (!isCreateMode || activeStep === 2) {
    <!-- Project Information Section -->
    <p-fieldset legend="Project Information">
        <div class="grid">
            <div class="col-12 md:col-6">
                <label for="projectNumber" class="modal-label">Project Number <span class="req">*</span></label>
                <div class="p-inputgroup project-number-inputgroup">

                    <input #projectNumberInput id="projectNumber" pInputText formControlName="projectNumber"
                        class="w-full p-inputtext-lg" tabindex="1" (blur)="projectId > 0 ? null : onProjectNumberBlur()"
                        [readonly]="projectId > 0"
                        [class.p-invalid]="(f['projectNumber'].invalid && f['projectNumber'].touched) || projectNumberVerificationStatus === 'failed'" />

                    @if (projectId > 0) {
                    <button type="button" pButton
                        [icon]="isRefreshingOracleProject ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
                        class="p-button-outlined p-button-secondary project-number-refresh-btn"
                        title="Refresh project data from Oracle"
                        [disabled]="isRefreshingOracleProject || isSaving || f['projectNumber'].invalid"
                        (click)="refreshOracleProjectData()"></button>
                    }

                    @if (projectNumberVerificationStatus === 'verified') {
                    <span class="p-inputgroup-addon bg-green-100 text-green-800">
                        <i class="pi pi-check text-green-600"></i>
                    </span>
                    } @else if (projectNumberVerificationStatus === 'failed') {
                    <span class="p-inputgroup-addon bg-red-100 text-red-800">
                        <i class="pi pi-times text-red-600"></i>
                    </span>
                    }
                </div>

                @if (f['projectNumber'].invalid && f['projectNumber'].touched) {
                <small class="modal-error">
                    Project number is required
                </small>
                } @else if (projectNumberVerificationStatus === 'verified') {
                <small class="text-green-600 block mt-1">
                    <i class="pi pi-check-circle mr-1"></i>Project number verified successfully
                </small>
                } @else if (projectNumberVerificationStatus === 'failed') {
                <small class="modal-error">
                    <i class="pi pi-exclamation-triangle mr-1"></i>{{ projectNumberErrorMessage }}
                </small>
                } @else if (projectNumberVerificationStatus === 'verifying') {
                <small class="text-blue-600 block mt-1">
                    Verifying project number...
                </small>
                }
            </div>

            <div class="col-12 md:col-6">
                <label for="projectName" class="modal-label">Project Name <span class="req">*</span></label>
                <input id="projectName" type="text" pInputText readonly formControlName="projectName"
                    class="w-full p-inputtext-lg" tabindex="2"
                    [class.p-invalid]="f['projectName'].invalid && f['projectName'].touched" />
                @if (f['projectName'].invalid && f['projectName'].touched) {
                <small class="modal-error">
                    Project name is required
                </small>
                }
            </div>

            <!-- Oracle EBS Auto-Populated Fields (Read-Only) -->
            <div class="col-12 md:col-6">
                <label for="projectManager" class="modal-label">Project Manager</label>
                <input id="projectManager" type="text" pInputText readonly formControlName="projectManager"
                    class="w-full p-inputtext-lg surface-100" />
            </div>

            <div class="col-12 md:col-6">
                <label for="engineer" class="modal-label">Engineer</label>
                <input id="engineer" type="text" pInputText readonly formControlName="engineer"
                    class="w-full p-inputtext-lg surface-100" />
            </div>

            <div class="col-12 md:col-6">
                <label for="projectCoordinator" class="modal-label">Project Coordinator</label>
                <input id="projectCoordinator" type="text" pInputText readonly formControlName="projectCoordinator"
                    class="w-full p-inputtext-lg surface-100" />
            </div>

            <div class="col-12 md:col-6">
                <label for="commProject" class="modal-label">Comm Project</label>
                <input id="commProject" type="text" pInputText readonly formControlName="commProject"
                    class="w-full p-inputtext-lg surface-100" />
            </div>

            <div class="col-12 md:col-6">
                <label for="warrantyProject" class="modal-label">Warranty Project</label>
                <input id="warrantyProject" type="text" pInputText readonly formControlName="warrantyProject"
                    class="w-full p-inputtext-lg surface-100" />
            </div>

            <div class="col-12 md:col-6">
                <label for="projectStatusId" class="modal-label">Project Status <span class="req">*</span></label>
                <p-select
                    inputId="projectStatusId"
                    formControlName="projectStatusId"
                    [options]="projectStatusOptions"
                    optionLabel="name"
                    optionValue="projectStatusId"
                    placeholder="Select Project Status"
                    appendTo="body"
                    class="w-full"
                    [class.p-invalid]="f['projectStatusId'].invalid && f['projectStatusId'].touched">
                </p-select>
            </div>
            @if (!isGIBusinessUnit) {
            <div class="col-12 md:col-6">
                <label for="projectType" class="modal-label">Project Type <span class="req">*</span></label>
                <p-select
                    inputId="projectType"
                    formControlName="projectType"
                    [options]="projectTypeOptions"
                    placeholder="Select Project Type"
                    appendTo="body"
                    class="w-full"
                    [class.p-invalid]="f['projectType'].invalid && f['projectType'].touched">
                </p-select>

            </div>
            <div class="col-12 md:col-6">
                <label for="inverterModelId" class="modal-label">Inverter Model <span class="req">*</span></label>
                <p-select
                    inputId="inverterModelId"
                    formControlName="inverterModelId"
                    [options]="inverterModelOptions"
                    optionLabel="name"
                    optionValue="inverterModelId"
                    placeholder="Select Inverter Model"
                    appendTo="body"
                    class="w-full"
                    [class.p-invalid]="f['inverterModelId'].invalid && f['inverterModelId'].touched">
                </p-select>
            </div>
            }
        </div>
    </p-fieldset>

    <!-- Customer Information Section -->
    <p-fieldset legend="Customer Information">
        <div class="grid">
            <div class="col-12 md:col-6">
                <label for="customerName" class="modal-label">Customer Name</label>
                <input id="customerName" type="text" pInputText formControlName="customerName"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="endUserName" class="modal-label">End User Name</label>
                <input id="endUserName" type="text" pInputText formControlName="endUserName"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="siteContact" class="modal-label">Site Contact</label>
                <input id="siteContact" type="text" pInputText formControlName="siteContact"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="customerContactNumber" class="modal-label">Contact Number</label>
                <input id="customerContactNumber" type="tel" pInputText formControlName="customerContactNumber"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12">
                <label for="customerEmailAddress" class="modal-label">Email Address</label>
                <input id="customerEmailAddress" type="email" pInputText formControlName="customerEmailAddress"
                    class="w-full p-inputtext-lg"
                    [class.p-invalid]="f['customerEmailAddress'].invalid && f['customerEmailAddress'].touched" />
                @if (f['customerEmailAddress'].invalid && f['customerEmailAddress'].touched) {
                <small class="modal-error">
                    Please enter a valid email address
                </small>
                }
            </div>

            <div class="col-12">
                <label for="customerAddress1" class="modal-label">Address Line 1</label>
                <input id="customerAddress1" type="text" pInputText formControlName="customerAddress1"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="customerAddress2" class="modal-label">Address Line 2</label>
                <input id="customerAddress2" type="text" pInputText formControlName="customerAddress2"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="customerCity" class="modal-label">City <span class="req">*</span></label>
                <input id="customerCity" type="text" pInputText formControlName="customerCity"
                    class="w-full p-inputtext-lg"
                    [class.p-invalid]="f['customerCity'].invalid && f['customerCity'].touched" />
                @if (f['customerCity'].invalid && f['customerCity'].touched) {
                <small class="modal-error">
                    City is required
                </small>
                }
            </div>

            <div class="col-12 md:col-4">
                <label for="customerState" class="modal-label">State <span class="req">*</span></label>
                <input id="customerState" type="text" pInputText formControlName="customerState"
                    class="w-full p-inputtext-lg"
                    [class.p-invalid]="f['customerState'].invalid && f['customerState'].touched" />
                @if (f['customerState'].invalid && f['customerState'].touched) {
                <small class="modal-error">
                    State is required
                </small>
                }
            </div>

            <div class="col-12 md:col-4">
                <label for="countryId" class="modal-label">Country</label>
                <p-select
                    inputId="countryId"
                    formControlName="countryId"
                    [options]="countryOptions"
                    optionLabel="countryName"
                    optionValue="countryId"
                    placeholder="Select Country"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>

            <div class="col-12 md:col-4">
                <label for="customerZip" class="modal-label">ZIP Code</label>
                <input id="customerZip" type="text" pInputText formControlName="customerZip"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="latitude" class="modal-label">Latitude</label>
                <input id="latitude" type="text" pInputText formControlName="latitude"
                    class="w-full p-inputtext-lg" />
            </div>

            <div class="col-12 md:col-6">
                <label for="longitude" class="modal-label">Longitude</label>
                <input id="longitude" type="text" pInputText formControlName="longitude"
                    class="w-full p-inputtext-lg" />
            </div>
            <div class="col-12">
                <label for="notes" class="modal-label">Notes</label>
                <textarea id="notes" formControlName="notes" rows="4"
                    class="w-full p-3 border-1 border-300 border-round surface-0 text-900">
            </textarea>
            </div>
        </div>
    </p-fieldset>


    <!-- MV Power Station Information Section -->
    @if (!isGIBusinessUnit) {
    <p-fieldset legend="MV Power Station Information">
        <div class="grid">
            <div class="col-12 md:col-6">
                <label for="transformerId" class="modal-label">Transformer</label>
                <p-select
                    inputId="transformerId"
                    formControlName="transformerId"
                    [options]="transformerOptions"
                    optionLabel="name"
                    optionValue="transformerId"
                    placeholder="Select Transformer"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>

            <div class="col-12 md:col-6">
                <label for="integratorId" class="modal-label">Integrator <span class="req">*</span></label>
                <p-select
                    inputId="integratorId"
                    formControlName="integratorId"
                    [options]="integratorOptions"
                    optionLabel="name"
                    optionValue="integratorId"
                    placeholder="Select Integrator"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <div class="col-12 md:col-6">
                <label for="startDate" class="modal-label">Start Date <span class="req">*</span></label>
                <p-datepicker inputId="startDate" [showIcon]="true" formControlName="startDate" class="w-full"
                    [class.p-invalid]="f['startDate'].invalid && f['startDate'].touched" [inline]="false"
                    [showOnFocus]="false" appendTo="body" tabindex="15" />
                @if (f['startDate'].invalid && f['startDate'].touched) {
                <small class="modal-error">
                    Start date is required
                </small>
                }
            </div>
            <div class="col-12 md:col-6">
                <label for="deliveryDate" class="modal-label">Delivery Date <span class="req">*</span></label>
                <p-datepicker inputId="deliveryDate" [showIcon]="true" formControlName="deliveryDate" class="w-full"
                    [class.p-invalid]="f['deliveryDate'].invalid && f['deliveryDate'].touched" />
                @if (f['deliveryDate'].invalid && f['deliveryDate'].touched) {
                <small class="modal-error">
                    Delivery date is required
                </small>
                }
            </div>
            <div class="col-12 md:col-6">
                <label for="cxStartDate" class="modal-label">Comm Start Date</label>
                <p-datepicker inputId="cxStartDate" [showIcon]="true" formControlName="cxStartDate" class="w-full" />
            </div>
            <div class="col-12 md:col-6">
                <label for="numberGfci" class="modal-label">Number of GFCI</label>
                <p-select
                    inputId="numberGfci"
                    formControlName="numberGfci"
                    [options]="cfgiOptions"
                    placeholder="Select Number of GFCI"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <div class="col-12">
                <label class="modal-label">MV Power Station Configuration <span class="req">*</span></label>
                <div class="grid">
                    <div class="col text-center font-medium text-900">N1</div>
                    <div class="col text-center font-medium text-900">N2</div>
                    <div class="col text-center font-medium text-900">N3</div>
                    <div class="col text-center font-medium text-900">N4</div>
                    <div class="col text-center font-medium text-900">N5</div>
                    <div class="col text-center font-medium text-900">N6</div>
                    <div class="col text-center font-medium text-900">N7</div>
                    <div class="col text-center font-medium text-900">MVPS</div>
                </div>
                <div class="flex gap-2">
                    <input type="number" pInputText formControlName="n1" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n2" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n3" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n4" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n5" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n6" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <input type="number" pInputText formControlName="n7" min="0" max="999"
                        [class]="'w-full p-inputtext-lg text-center' + (projectId > 0 ? ' surface-100' : '')"
                        (blur)="changeSkid()" (input)="changeSkid()"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" [readonly]="projectId > 0" />
                    <div class="flex align-items-center justify-content-center" style="width: 40px;">
                        <span class="font-bold text-xl">=</span>
                    </div>
                    <input type="number" pInputText formControlName="skids" readonly
                        class="w-full p-inputtext-lg text-center surface-100"
                        [class.p-invalid]="f['skids'].invalid && f['skids'].touched" />
                </div>
                @if (f['skids'].invalid && f['skids'].touched && f['skids'].errors?.['skidConfigurationRequired']) {
                <small class="modal-error">
                    <i class="pi pi-exclamation-triangle mr-1"></i>At least one MV Power Station configuration (N1-N6) must have a
                    value greater than 0
                </small>
                }
            </div>

            <div class="col-12 md:col-6">
                <label for="auxPackage" class="modal-label">Auxiliary Package <span class="req">*</span></label>
                <p-select
                    inputId="auxPackage"
                    formControlName="auxPackage"
                    [options]="auxPackageOptions"
                    placeholder="Select Auxiliary Package"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>

            <div class="col-12 md:col-6">
                <label for="oilContainment" class="modal-label">Oil Containment <span class="req">*</span></label>
                <p-select
                    inputId="oilContainment"
                    formControlName="oilContainment"
                    [options]="oilContainmentOptions"
                    placeholder="Select Oil Containment"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>

            <div class="col-12 md:col-6">
                <label for="auxiliaryRackLight" class="modal-label">Auxiliary Rack Light</label>
                <p-select
                    inputId="auxiliaryRackLight"
                    formControlName="auxiliaryRackLight"
                    [options]="auxiliaryRackLightOptions"
                    placeholder="Select Auxiliary Rack Light"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <div class="col-12 md:col-6">
                <label for="incoTermsId" class="modal-label">Inco Terms <span class="req">*</span></label>
                <p-select
                    inputId="incoTermsId"
                    formControlName="incoTermsId"
                    [options]="incoTermsOptions"
                    optionLabel="name"
                    optionValue="incotermId"
                    placeholder="Select Inco Terms"
                    appendTo="body"
                    class="w-full">
                </p-select>
            </div>

            <div class="col-12 md:col-6">
                <label for="backfeedDate" class="modal-label">Backfeed Date</label>
                <p-datepicker inputId="backfeedDate" [showIcon]="true" formControlName="backfeedDate" class="w-full" />
            </div>


            <div class="col-12 md:col-6">
                <label for="freightBroker" class="modal-label">Freight Broker</label>
                <input id="freightBroker" type="text" pInputText formControlName="freightBroker"
                    class="w-full p-inputtext-lg" />
            </div>
        </div>
    </p-fieldset>
    }
    }

    @if (isCreateMode && activeStep === 3) {
    <div class="step3-content">
        <i class="pi pi-check-circle step3-icon"></i>
        <h3 class="step3-title">Project Saved Successfully</h3>
        <p class="step3-subtitle">The project has been created.</p>
    </div>
    }
    </div>

    <!-- Form Actions -->
    <div class="modal-footer">
        <button type="button" class="modal-btn-cancel" (click)="onClose()">Close</button>
        @if (isCreateMode && activeStep === 1) {
        <button type="button" class="modal-btn-primary" [disabled]="isCreateButtonDisabled || isSaving" (click)="goToDetailsStep()">
            Next
        </button>
        } @else if (isCreateMode && activeStep === 3) {
        <button type="button" class="modal-btn-primary" (click)="onClose()">Done</button>
        } @else {
        @if (isCreateMode) {
        <button type="button" class="modal-btn-cancel modal-btn-back-left" (click)="goToBusinessUnitStep()">Back</button>
        }
        <button type="submit" class="modal-btn-primary" [disabled]="isCreateButtonDisabled || isSaving">
            @if (isSaving) {
                Saving...
            } @else if (projectId > 0) {
                Save Changes
            } @else if (!isProjectNumberVerified && projectNumberVerificationStatus !== 'none') {
                Verify Project Number First
            } @else {
                Create Project
            }
        </button>
        }
    </div>
</form>
